import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { setJsonLd } from "@/lib/seo";

export const FAQ = [
  ["Hvor kan jeg få tilpasset bunad i Bergen?", "Hos SømSignature i Birkeveien 2, 5093 Bergen. Vi tilpasser og justerer alle typer bunader – nye, arvede og herrebunader. Bunadskonsultasjonen er gratis. Bestill i god tid før 17. mai og konfirmasjon."],
  ["Hva koster det å legge opp bukser?", "Opplegging av bukser koster 350–500 kr. Alle priser er veiledende; endelig pris avtales før arbeidet starter."],
  ["Kan jeg få klærne mine raskt?", "Ekspress innen 24 timer kan avtales, avhengig av kapasitet og arbeidets omfang. Tillegget er 40 %. Vanlig leveringstid er rundt 2 uker."],
  ["Syr dere brudekjoler?", "Ja. Du kan få brudekjolen skreddersydd av Liisa, eller sy din egen brudekjole med personlig veiledning. Tilpasning av brudekjole koster fra 1 500 kr."],
  ["Har dere sykurs i Bergen?", "Ja, individuell syundervisning med veiledende pris ca. 1 000 kr for 2 timer. Atelieret har symaskiner og redskaper du kan bruke; du tar med eget stoff."],
  ["Må jeg bestille time?", "Det anbefales. Du kan bestille gratis prøvetime (10–15 min) i bookingkalenderen, eller sende en forespørsel om pristilbud på nettsiden."],
  ["Hvor ligger atelieret og når er det åpent?", "Birkeveien 2, 5093 Bergen (lokale med store vinduer). Åpent mandag–fredag 10–17, andre tider etter avtale. Telefon 90402421."],
];

export const FaqSection = ({ items = FAQ, title = "Ofte stilte spørsmål", testid = "faq" }) => {
  useEffect(() => {
    setJsonLd("faq-jsonld", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
    });
    return () => document.getElementById("faq-jsonld")?.remove();
  }, [items]);
  return (
    <section className="px-6 md:px-16 lg:px-24 py-24 border-t border-[#E5E0D8]" data-testid={`${testid}-section`}>
      <div className="grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow mb-4">Spørsmål og svar</p>
          <h2 className="text-4xl md:text-5xl font-medium tracking-tight">{title}</h2>
        </Reveal>
        <Accordion type="single" collapsible className="lg:col-span-8">
          {items.map(([q, a], i) => (
            <AccordionItem key={q} value={`f${i}`} data-testid={`${testid}-item-${i}`}>
              <AccordionTrigger className="text-left font-serif-display text-xl md:text-2xl">{q}</AccordionTrigger>
              <AccordionContent className="text-[#5C5A56] leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
